import React from "react";

const RequiredAsterisk = ({ show, style }) => {
  return show ? <small style={{ marginLeft: "5px", ...style }}>*</small> : "";
};

export default RequiredAsterisk;
